import React, { useContext } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { ErrorShapeIcon } from '../../../../../assets/images/error-shape';
import { RichText } from '../../../../hoc/components/rich-text';
import context from '../../../../hoc/context/product/context';

export const ErrorsDisplay: React.FC<{
	errors: UseFormMethods['errors'];
}> = ({ errors }) => {
	const ctxt = useContext(context);
	return Object.keys(errors).length > 0 ? (
		<div
			className="my-12 flex border-2 border-error justify-center"
			data-testid="errors-display-wrapper">
			<div className="mx-4 my-3 md:my-8 md:mx-auto text-error w-auto text-center">
				<h2 className="text-2xl">
					<ErrorShapeIcon className="mr-1 inline fill-error" />{' '}
					<RichText html={ctxt.json.pages.userProfile.formError} />
				</h2>
				<p className="text-lg">
					<RichText html={ctxt.json.pages.userProfile.formErrorDescription} />
				</p>
			</div>
		</div>
	) : (
		<></>
	);
};

export default ErrorsDisplay;
